import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { LiaEditSolid } from "react-icons/lia";
import Edit from "./Edit";
import Header from '../Header/HeaderHome';

const Home = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("recently");
  const [expenses, setExpenses] = useState([]);
  const [expensesDetail, setExpensesDetail] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [expandedExpense, setExpandedExpense] = useState(null);
  const [graphData, setGraphData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editExpense, setEditExpense] = useState(null);
  const [formData, setFormData] = useState({
    description: "",
    category: "",
    subCategory: "",
    date: "",
    amount: "",
  });

  const handleOpenModal = (expense) => {
    console.log("expense",expense)
      setEditExpense(expense);
      setFormData({
        description: expense?.description,
        category: expense?.category,
        subCategory: expense?.subCategory,
        date:  expense?.date ? expense?.date.split("T")[0] : "",
        amount: expense?.amount,
      });
      setOpenModal(true);
    };
  
    const handleCloseModal = () => {
      setOpenModal(false);
      setFormData({
        description: "",
        category: "",
        subCategory: "",
        date: "",
        amount: "",
      })
      setEditExpense(null);
    };
    
  useEffect(() => {
    const token = localStorage.getItem("tokenexpense");
    if (!token) {
      navigate("/welcome");
    } else {
      fetchExpenses(token, 1, activeFilter);
    }
  }, [navigate,activeFilter]);

  const fetchExpenses = async (token, currentPage, filter) => {
    try {
      const apiUrl = `https://expense.dpstrust.in/api/expense/all?page=${currentPage}&limit=10`;
      const filterQuery = filter && filter !== "recently" ? `&filter=${filter}` : "";
      const response = await axios.get(`${apiUrl}${filterQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setGraphData(response.data.data.graphData);
      setExpensesDetail(response.data.data);
      if (response.data.status) {
        const newExpenses = response.data.data.expenses;

        // Filter out duplicates
        const uniqueExpenses = Array.from(
          new Map(
            [...expenses, ...newExpenses].map((item) => [item._id, item])
          ).values()
        );

        setExpenses(uniqueExpenses);
        if (newExpenses.length < 10) {
          setHasMore(false); // No more pages to load
        }
      }
    } catch (error) {
      console.error("Error fetching expenses:", error);
      setHasMore(false); // Stop loading on error
    }
  };

  const loadMoreExpenses = () => {
    const token = localStorage.getItem("tokenexpense");
    const nextPage = page + 1;
    setPage(nextPage);
    fetchExpenses(token, nextPage, activeFilter);
  };

  const chartData = {
    labels: expensesDetail?.graphData?.map((item) => item.category),
    datasets: [
      {
        label: "Expenses",
        data: expensesDetail?.graphData?.map((item) => item.totalExpense),
        backgroundColor: "orange",
        borderRadius: 5,
        barThickness: 20,
      },
    ],
  };
  
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems) => {
            const index = tooltipItems[0].dataIndex;
            return expensesDetail.graphData[index].category;
          },
          label: (tooltipItem) => {
            const index = tooltipItem.dataIndex;
            const subcategories =
              expensesDetail.graphData[index].contributionOfSubcategory;
            return Object.entries(subcategories)
              .map(([subcategory, value]) => `${subcategory}: ${value}`)
              .join(", ");
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#fff",
        },
      },
      y: {
        ticks: {
          color: "#fff",
        },
        grid: {
          color: "rgba(255, 255, 255, 0.2)",
        },
      },
    },
  };
  

  const handleFilterChange = (filter) => {
    setActiveFilter(filter.toLowerCase());
    setExpenses([]);
    setPage(1); 
    setHasMore(true);
  };

  const toggleExpenseExpansion = (id) => {
    setExpandedExpense(expandedExpense === id ? null : id);
  };

  const userInitials = localStorage.getItem("userInitials");


  return (<>
        <Header heading="Expenses" />

    <div className="home-container" style={{paddingTop:"70px"}}>
  <div className="headinghome">Expenses</div>
  <div className="headingsubhome">
    ₹ {expensesDetail?.totalExpense}
  </div>
  <div className="chart-container">
    <Bar data={chartData} options={chartOptions} />
  </div>

  <div className="filter-buttons">
    {["Recently","Monthly", "Weekly", "Today"].map((filter) => (
      <button
        key={filter}
        className={`filter-button ${
          activeFilter === filter.toLowerCase() ? "active" : ""
        }`}
        onClick={() => handleFilterChange(filter)}
      >
        {filter}
      </button>
    ))}
  </div>

  {expenses.length === 0 && !hasMore && (
    <p style={{ textAlign: "center", color: "red" }}>No expenses available</p>
  )}
 
  <InfiniteScroll
    dataLength={expenses.length}
    next={loadMoreExpenses}
    hasMore={hasMore}
    loader={<h4>Loading more expenses...</h4>}
    endMessage={
      expenses.length > 0 ? (
        <p style={{ textAlign: "center" }}>No more expenses</p>
      ) : null
    }
  >
            <ul className="home-list">
          {expenses?.map((item) => {
    const getUserInitials = () => {
      const { firstName, lastName } = item?.user || {};
      const firstInitial = firstName?.charAt(0).toUpperCase() || "";
      const lastInitial = lastName?.charAt(0).toUpperCase() || "";
      return lastInitial ? `${firstInitial}${lastInitial}` : firstInitial;
    };

return (
            <li
              key={item?._id}
              className="home-item"
            >
              <div className="contlist" >{(item?.receiptFrontSideImage || item?.receiptBackSideImage || item?.description || item?.date) && (
  expandedExpense === item?._id ? (
    <IoIosArrowUp
      style={{ color: "#000", marginRight:"10px" }}
      onClick={() => toggleExpenseExpansion(item._id)}
    />
  ) : (
    <IoIosArrowDown
      style={{ color: "#000", marginRight:"10px" }}
      onClick={() => toggleExpenseExpansion(item._id)}
    />
  )
)} 
              <div className="home-image">{getUserInitials()}</div>
              <div className="home-details">
                <div className="home-title" style={{ textTransform: "capitalize", color:"#42224A" }}>{item?.category}</div>
                {item?.subCategory && (<div className="home-title1" style={{ textTransform: "capitalize" }}>({item?.subCategory})</div>)}
              </div>
              <div className="home-price">₹ {item?.amount}</div>
              <div><LiaEditSolid size={30} style={{marginLeft:"10px", color:"#42222A", cursor:"pointer"}} onClick={()=>handleOpenModal(item)}/></div>
              </div>
           
             
              {expandedExpense === item._id && (
  <div className="expense-details">

    {item.description && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Description:</strong>
        <span style={{width:"200px", height:"auto", marginBottom:"10px"}}
        >{item?.description}
          </span>
      </div>
    )}
    {item.date && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Date:</strong>
        <span style={{width:"200px", height:"auto", marginBottom:"10px"}}
        >{new Date(item.date).toLocaleDateString()}
          </span>
      </div>
    )}
    {item.receiptFrontSideImage && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Receipt (Front):</strong>
        <img style={{width:"200px", height:"auto"}}
          // src="./card.png"
          src={item.receiptFrontSideImage}
          alt="Receipt Front"
          className="receipt-image"
        />
      </div>
    )}
    {item.receiptBackSideImage && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Receipt (Back):</strong>
        <img style={{width:"200px", height:"auto"}}
                  // src="./card.png"
          src={item.receiptBackSideImage}
          alt="Receipt Back"
          className="receipt-image"
        />
      </div>
    )}
  </div>
)}

            </li>
);
})}
        </ul>
  </InfiniteScroll>

  <Edit handleCloseModal={handleCloseModal} openModal={openModal} formData={formData} setFormData={setFormData} editExpense={editExpense} fetchExpenses={fetchExpenses} activeFilter={activeFilter} page={page}/>
</div>
</>
  );
};

export default Home;
